import { AddCircleOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"
import React from "react"

import { Button } from "@/components/common/Button"

const ActivateInstructionButton = ({ onClick }: { onClick: () => void }): ReactElement => {
  return (
    <Button size='small' appearance='outlined' onClick={onClick}>
      <AddCircleOutlined />
      Activate
    </Button>
  )
}

export default ActivateInstructionButton
